/**
 * FormFlu Main Application Component
 *
 * HIPAA COMPLIANCE NOTES:
 * - No PHI should be exposed in browser console logs
 * - No PHI in error boundaries or error messages
 * - No PHI in URL parameters or paths
 * - No PHI in page titles or meta tags
 * - All API calls go through the backend
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, TenantProvider } from './contexts';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Header, Hero, Features, Footer } from './components';
import { LoginPage, RegisterPage, FormsPage, FormBuilderPage, SubmissionsPage, AnalyticsPage, TeamPage, DashboardHomePage, SettingsPage, HelpPage } from './pages';
import { DashboardLayout } from './components/dashboard';

// Marketing Homepage
function HomePage() {
  const handleLogin = () => {
    window.location.href = '/login';
  };

  const handleSignup = () => {
    window.location.href = '/register';
  };

  const handleGetStarted = () => {
    window.location.href = '/register';
  };

  const handleWatchDemo = () => {
    // TODO: Implement demo video modal
    console.log('Watch Demo clicked');
  };

  return (
    <div className="app">
      <Header onLogin={handleLogin} onSignup={handleSignup} />
      <main>
        <Hero onGetStarted={handleGetStarted} onWatchDemo={handleWatchDemo} />
        <Features />
      </main>
      <Footer />
    </div>
  );
}

// Placeholder pages for routes
function PlaceholderPage({ title }: { title: string }) {
  return (
    <DashboardLayout title={title}>
      <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>
        <h2>{title}</h2>
        <p>This page is coming soon.</p>
      </div>
    </DashboardLayout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TenantProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            
            {/* Protected Dashboard Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardHomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/forms"
            element={
              <ProtectedRoute>
                <FormsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/forms/:formId"
            element={
              <ProtectedRoute>
                <FormBuilderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/forms/:formId/analytics"
            element={
              <ProtectedRoute>
                <AnalyticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/forms/:formId/submissions"
            element={
              <ProtectedRoute>
                <DashboardLayout title="Submissions">
                  <SubmissionsPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/submissions"
            element={
              <ProtectedRoute>
                <PlaceholderPage title="All Submissions" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/analytics"
            element={
              <ProtectedRoute>
                <PlaceholderPage title="Analytics" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/team"
            element={
              <ProtectedRoute>
                <TeamPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/help"
            element={
              <ProtectedRoute>
                <HelpPage />
              </ProtectedRoute>
            }
          />
          
            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </TenantProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
